import React from 'react';
import { AssetUrls } from 'config/assets';
import './ManaFilters.css';

const COLOR_OPTIONS = [
  { key: 'W', label: 'White', icon: AssetUrls.search.manaSymbols.white },
  { key: 'U', label: 'Blue', icon: AssetUrls.search.manaSymbols.blue },
  { key: 'B', label: 'Black', icon: AssetUrls.search.manaSymbols.black },
  { key: 'R', label: 'Red', icon: AssetUrls.search.manaSymbols.red },
  { key: 'G', label: 'Green', icon: AssetUrls.search.manaSymbols.green },
  { key: 'C', label: 'Colorless', icon: AssetUrls.search.manaSymbols.colorless },
];

interface ManaFiltersProps {
  selectedColors?: string[];
  onColorToggle?: (color: string) => void;
  /**
   * 'checkbox' (default) is the labelled pill row the legacy form uses.
   * 'pips' renders symbol-only buttons tinted in each colour's own hue, for the
   * Search filter panel and its mobile sheet.
   */
  variant?: 'checkbox' | 'pips';
  /** Pip diameter in px. Only meaningful for variant="pips". */
  size?: number;
}

export default function ManaFilters({
  selectedColors = [],
  onColorToggle,
  variant = 'checkbox',
  size,
}: ManaFiltersProps) {
  const handleColorChange = (colorKey: string) => {
    if (onColorToggle) {
      onColorToggle(colorKey);
    }
  };

  if (variant === 'pips') {
    return (
      <div className="mana-pips" role="group" aria-label="Colors">
        {COLOR_OPTIONS.map((color) => {
          const isSelected = selectedColors.includes(color.key);
          return (
            <button
              key={color.key}
              type="button"
              className={`mana-pip mana-pip-${color.key.toLowerCase()} ${isSelected ? 'selected' : ''}`}
              style={size ? { width: size, height: size } : undefined}
              aria-pressed={isSelected}
              aria-label={color.label}
              title={color.label}
              onClick={() => handleColorChange(color.key)}
            >
              <img src={color.icon} alt="" aria-hidden="true" />
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="mana-color-options">
      {COLOR_OPTIONS.map((color) => (
        <label key={color.key} className="mana-color-option">
          <input
            type="checkbox"
            checked={selectedColors.includes(color.key)}
            onChange={() => handleColorChange(color.key)}
          />
          <img src={color.icon} alt={color.label} />
          <span>{color.label}</span>
        </label>
      ))}
    </div>
  );
}
